// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-components-Form-Input-___Input-module__container {
  position: relative;
  flex-direction: row;
  height: 100%;
  flex: 1;
}

.app-components-Form-Input-___Input-module__fieldError {
  position: absolute;
  right: 0px;
}

.app-components-Form-Input-___Input-module__input {
  border: solid 1px var(--colors-grey);
  border-radius: var(--mainBorderRadius);
  box-sizing: border-box;
  display: block;
  outline: none;
  padding: 0px 10px;
  font-family: var(--mainFont);
  font-size: 16px;
  color: var(--colors-black);
  background-color: #fff;
  width: 100%;
  height: 100%;
  min-height: 30px;
}

/**
 * disable inputs number buttons
 */
.app-components-Form-Input-___Input-module__input[type='number']::-webkit-outer-spin-button,
.app-components-Form-Input-___Input-module__input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.app-components-Form-Input-___Input-module__input[type='number'] {
  -moz-appearance: textfield;
}

.app-components-Form-Input-___Input-module__input[type='date']::-webkit-calendar-picker-indicator {
  margin: 0;
}

.app-components-Form-Input-___Input-module__alignRight {
  text-align: right;
}

.app-components-Form-Input-___Input-module__resize {
  resize: vertical;
}

.app-components-Form-Input-___Input-module__input:disabled {
  background: #eeeeee;
  color: #888888;
  cursor: not-allowed;
}

.app-components-Form-Input-___Input-module__input.app-components-Form-Input-___Input-module__error {
  border-color: var(--colors-red);
  box-shadow: 0 0 3px var(--colors-red);
}

.app-components-Form-Input-___Input-module__inputAdornmentIcon {
  padding-right: 30px;
}

.app-components-Form-Input-___Input-module__adornmentIcon {
  color: #8d8d8d;
  width: 30px;
  height: 100%;
  top: 0;
  right: 0;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
}

.app-components-Form-Input-___Input-module__inputShowDateDay {
  padding-left: 30px;
}

.app-components-Form-Input-___Input-module__showDateDay {
  color: #8d8d8d;
  width: 30px;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./app/components/Form/Input/Input.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;EACf,0BAA0B;EAC1B,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE;AACF;;EAEE,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,MAAM;EACN,QAAQ;EACR,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":[".container {\n  position: relative;\n  flex-direction: row;\n  height: 100%;\n  flex: 1;\n}\n\n.fieldError {\n  position: absolute;\n  right: 0px;\n}\n\n.input {\n  border: solid 1px var(--colors-grey);\n  border-radius: var(--mainBorderRadius);\n  box-sizing: border-box;\n  display: block;\n  outline: none;\n  padding: 0px 10px;\n  font-family: var(--mainFont);\n  font-size: 16px;\n  color: var(--colors-black);\n  background-color: #fff;\n  width: 100%;\n  height: 100%;\n  min-height: 30px;\n}\n\n/**\n * disable inputs number buttons\n */\n.input[type='number']::-webkit-outer-spin-button,\n.input[type='number']::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.input[type='number'] {\n  -moz-appearance: textfield;\n}\n\n.input[type='date']::-webkit-calendar-picker-indicator {\n  margin: 0;\n}\n\n.alignRight {\n  text-align: right;\n}\n\n.resize {\n  resize: vertical;\n}\n\n.input:disabled {\n  background: #eeeeee;\n  color: #888888;\n  cursor: not-allowed;\n}\n\n.input.error {\n  border-color: var(--colors-red);\n  box-shadow: 0 0 3px var(--colors-red);\n}\n\n.inputAdornmentIcon {\n  padding-right: 30px;\n}\n\n.adornmentIcon {\n  color: #8d8d8d;\n  width: 30px;\n  height: 100%;\n  top: 0;\n  right: 0;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.inputShowDateDay {\n  padding-left: 30px;\n}\n\n.showDateDay {\n  color: #8d8d8d;\n  width: 30px;\n  height: 100%;\n  top: 0;\n  left: 0;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `app-components-Form-Input-___Input-module__container`,
	"fieldError": `app-components-Form-Input-___Input-module__fieldError`,
	"input": `app-components-Form-Input-___Input-module__input`,
	"alignRight": `app-components-Form-Input-___Input-module__alignRight`,
	"resize": `app-components-Form-Input-___Input-module__resize`,
	"error": `app-components-Form-Input-___Input-module__error`,
	"inputAdornmentIcon": `app-components-Form-Input-___Input-module__inputAdornmentIcon`,
	"adornmentIcon": `app-components-Form-Input-___Input-module__adornmentIcon`,
	"inputShowDateDay": `app-components-Form-Input-___Input-module__inputShowDateDay`,
	"showDateDay": `app-components-Form-Input-___Input-module__showDateDay`
};
export default ___CSS_LOADER_EXPORT___;
